<template>
  <div class="card card-custom gutter-b example example-compact">
    <div class="card-header">
      <div class="card-title">
        <h3>Allgemeine Einstellungen</h3>
      </div>
    </div>
    <div class="card-body">
      <div class="listing-form-main">
        <ValidationObserver ref="newServiceForm">
          <b-form class="form" @submit.stop.prevent="onSubmit">
            <div class="row">
              <div class="col-md-6">
                <span>
                  Dieser Steuersatz wird auf alle Bestellungen angewendet
                </span>
                <b-form-group class="mt-5">
                  <ValidationProvider
                    rules="priceInput"
                    v-slot="{ errors }"
                    :custom-messages="{
                      required: 'This is required.',
                    }"
                  >
                    <v-text-field
                      :error-messages="errors[0]"
                      autocomplete="new-password"
                      v-model="form.tax"
                      label="Steuer (%)"
                      outlined
                      clearable
                    ></v-text-field>
                  </ValidationProvider>
                </b-form-group>

                <!-- <b-form-group class="mt-5">
                  <v-switch
                    v-model="form.status"
                    inset
                    :label="form.status == true ? 'Active' : 'Inactive'"
                  ></v-switch>
                </b-form-group> -->
              </div>
              <div class="col-md-6">
                <span>
                  Diese Provision wird auf alle Bestellungen angewendet
                </span>
                <b-form-group class="mt-5">
                  <ValidationProvider
                    rules="priceInput"
                    v-slot="{ errors }"
                    :custom-messages="{
                      required: 'This is required.',
                    }"
                  >
                    <v-text-field
                      :error-messages="errors[0]"
                      autocomplete="new-password"
                      v-model="form.dealerCommission"
                      label="Provision (%)"
                      outlined
                    ></v-text-field>
                  </ValidationProvider>
                </b-form-group>
              </div>

              <div class="col-md-6">
                <v-divider></v-divider>
                <span>
                  Der Kunde wird automatisch gelöscht, wenn er für folgenden
                  Zeitraum inaktiv ist
                </span>
                <b-form-group class="mt-5">
                  <ValidationProvider
                    rules="min_value:1"
                    v-slot="{ errors }"
                    :custom-messages="{
                      required: 'This is required.',
                    }"
                  >
                    <v-text-field
                      type="number"
                      :error-messages="errors[0]"
                      autocomplete="new-password"
                      v-model="form.period"
                      label="Periode (Monate)"
                      outlined
                      clearable
                    ></v-text-field>
                  </ValidationProvider>
                </b-form-group>
              </div>

              <div class="col-md-6">
                <v-divider></v-divider>
                <span>
                  Der Administrator wird nach dieser Zeit automatisch
                  ausgelogged
                </span>
                <b-form-group class="mt-5">
                  <ValidationProvider
                    rules="min_value:1"
                    v-slot="{ errors }"
                    :custom-messages="{
                      required: 'This is required.',
                    }"
                  >
                    <v-text-field
                      type="number"
                      :error-messages="errors[0]"
                      autocomplete="new-password"
                      v-model="form.logoutTime"
                      label="Zeit bis zum automatischen Logout (Minuten)"
                      outlined
                      clearable
                    ></v-text-field>
                  </ValidationProvider>
                </b-form-group>
              </div>
            </div>
            <div class="fo-row-btn text-right">
              <v-btn class="submit-btn-fill-outline" @click="goToBack">
                Abbrechen
              </v-btn>
              <v-btn
                type="Speichern"
                :disabled="isDisabled"
                ref="kt_form_submit_btn"
                class="submit-btn-fill-color"
              >
                {{ submitText }}
              </v-btn>
            </div>
          </b-form>
        </ValidationObserver>
      </div>
    </div>
    <notifications group="setting" position="bottom right" />
  </div>
</template>

<script>
import Vue from "vue";
import { mapGetters } from "vuex";
import axios from "axios";
import Notifications from "vue-notification";
import JwtService from "@/core/services/jwt.service";
import vue2Dropzone from "vue2-dropzone";
import "vue2-dropzone/dist/vue2Dropzone.min.css";
import adminAPI from "@/api/admin";
import { extend } from "vee-validate";
Vue.use(Notifications);

extend("priceInput", {
  message: (field) => "enter valid value",
  validate: (value) => {
    var regx = /^[0-9.,]+$/;
    var validInput = regx.test(value);
    if (validInput) {
      return true;
    } else {
      false;
    }
  },
});

export default {
  name: "GeneralSettings",
  created() {
    if (!this.isAuthenticated) {
      this.$router.push({ name: "Login" });
    } else {
      this.getGeneralSetting();
    }
  },
  data() {
    return {
      formError: false,
      settingId: "",
      formData: [],
      types: [],
      btnDisable: false,
      submitText: "Speichern",
      form: {
        tax: "",
        // commission: "",
        period: "",
        logoutTime: "",
        dealerCommission: "",
      },
    };
  },
  methods: {
    goToBack() {
      this.$router.push({ name: "admin-dashboard" });
    },
    getGeneralSetting() {
      adminAPI
        .getGeneralSetting({ id: this.currentUser.id })
        .then((response) => {
          if (response.status == "success") {
            this.settingId = response.data.id;
            this.form.tax = response.data.tax;
            // this.form.commission = response.data.commission;
            this.form.period = response.data.customer_delete_in_month;
            this.form.logoutTime = response.data.logout_time;
            this.form.dealerCommission = response.data.dealer_commission;
            // this.form.status = response.data[0].is_allowed == 1 ? true : 0;
          } else {
            this.$notify({
              group: "setting",
              type: "error",
              position: "bottom right",
              text: response.msg,
              duration: 5000,
            });
          }
        })
        .catch((err) => {
          this.btnDisable = false;
          this.submitText = "Speichern";
          this.$notify({
            group: "setting",
            type: "error",
            position: "bottom right",
            text: err,
            duration: 5000,
          });
        });
    },
    onSubmit() {
      this.$refs.newServiceForm.validate().then((success) => {
        if (success) {
          this.btnDisable = true;
          this.submitText = "Wird gespeichert...";
          let fd = new FormData();
          fd.append("id", this.settingId);
          fd.append("tax", this.form.tax);
          // fd.append("commission", this.form.commission);
          fd.append("customer_delete_in_month", this.form.period);
          fd.append("logout_time", this.form.logoutTime);
          fd.append("dealer_commission", this.form.dealerCommission);
          setTimeout(() => {
            adminAPI
              .addGeneralSetting(fd)
              .then((response) => {
                if (response.status == "success") {
                  this.submitText = "Speichern";
                  this.btnDisable = false;
                  this.$notify({
                    group: "setting",
                    type: "success",
                    position: "bottom right",
                    text: response.msg,
                    duration: 5000,
                  });
                  this.getGeneralSetting();
                } else {
                  this.btnDisable = false;
                  this.submitText = "Speichern";

                  this.$notify({
                    group: "setting",
                    type: "error",
                    position: "bottom right",
                    text: response.msg,
                    duration: 5000,
                  });
                }
              })
              .catch((err) => {
                this.btnDisable = false;
                this.submitText = "Speichern";
                this.$notify({
                  group: "setting",
                  type: "error",
                  position: "bottom right",
                  text: err,
                  duration: 5000,
                });
              });
          }, 2000);
        } else {
          this.$notify({
            group: "setting",
            type: "error",
            position: "bottom right",
            text: 'fehlender obligatorischer Wert oder falsches Format',
            duration: 5000,
          });
          this.formError = true;
          this.btnDisable = false;
          this.submitText = "Speichern";
        }
      });
    },
  },
  computed: {
    ...mapGetters(["isAuthenticated", "currentUser"]),
    isDisabled: function () {
      return this.btnDisable;
    },
  },
};
</script>

<style scoped>
h3 {
  font-family: "ubuntu";
  color: #000;
}

.form-errors {
  color: red;
}

.submit-button {
  background-color: #3d5a80 !important;
}

.submit-button:hover {
  background-color: #002c47 !important;
}

.spinner.spinner-right {
  padding-right: 3.5rem !important;
}
</style>
